"use client";

import { SearchX, Home, ArrowLeft, Compass } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex items-center justify-center">
      <div className="flex flex-col w-full items-center text-center mt-15 px-8 md:px-0 md:mt-30 py-10 md:py-20">

        {/* 404 Large Text */}
        <div className="mb-4 md:mb-8">
          <h1 className="text-6xl md:text-9xl font-bold text-grey bg-clip-text animate-pulse">404</h1>
        </div>
        
        {/* Title */}
        <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-3">Page Not Found</h2>
        
        {/* Description */}
        <p className="text-sm md:text-base text-gray-600 mb-2">Oops! The page you&apos;re looking for doesn&apos;t exist.</p>
        <p className="text-sm md:text-base text-gray-500 mb-4 md:mb-8">It might have been moved, deleted, or the URL might be incorrect.</p>
        
        {/* Action Buttons */}
        <Link
          href="/"
          className="w-fit inline-flex items-center justify-center gap-2 px-4 md:px-6 py-1.5 md:py-3 bg-secondary text-xs md:text-sm text-white rounded-lg hover:bg-gray-800 transition-colors font-normal"
        >
          <Home className="w-4 h-4 md:w-5 md:h-5" />
          Back to home
        </Link>
            
      </div>
    </div>
  );
}